import React from 'react';

export const PreloadContext = React.createContext(false);
